<template>
	<div class="contentWarp" ref="warp">
		<a-modal
			v-model:visible="isShow"
			:title="title"
			:footer="null"
			:confirm-loading="confirmLoading"
			:getContainer="() => this.$refs.warp"
			:afterClose="reset"
		>
			<div class="TransactionsModal-wrap-tips">
				<p class="contentText" v-html="text"></p>
			</div>

			<div id="button" class="TransactionsModal-wrap-body">
				<a-input-group compact class="buttonGroup" style="">
					<a-textarea
						v-model:value="entity.linkUrl"
						:rows="3"
						style="border-radius: 15px; text-align: left"
						@blur="focus"
						@input="focus"
						placeholder="请输入TK主页链接，例如【https://www.tikok.com/@xxxx】换行为一条数据"
					/>
				</a-input-group>
				<a-input-group compact class="buttonGroup">
					<a-select
						placeholder="请选择投放数量"
						ref="select"
						v-model:value="entity.orderCount"
						style="width: 100%; border-radius: 15px; text-align: left"
						@blur="focus"
					>
						<a-select-option
							v-for="item in touliuSelect"
							v-bind:key="item.value"
							:value="item.value"
							>{{ item.disc }}</a-select-option
						>
					</a-select>
				</a-input-group>
				<a-input-group compact class="buttonGroup">
					<a-input
						disabled="disabled"
						v-model:value="entity.orderNum"
						style="
							width: 80%;
							border-radius: 15px;
							background-color: white;
							color: #0086f5ff;
							text-align: center;
						"
						placeholder=""
					/>
					<a-button
						type="primary"
						style="border-radius: 15px; margin-left: -50px; z-index: 9999"
						@click="order()"
					>
						{{ this.$lang.GetLangByKey('Order') }}</a-button
					>
				</a-input-group>
			</div>
			<promotion-home :promotionType="1" />
			<order-success-modal
				v-model:visible="orderSuccessVisible"
				@changeVisible="orderSuccesschangeVisible"
			></order-success-modal>
		</a-modal>
	</div>
</template>
<script>
	import orderApi from '@/http/apiUtil/orderApi';
	import util from '@/common/util.js';
	import promotionHome from '@/components/promotion/promotionHome.vue';
	import orderSuccessModal from '@/components/order/orderSuccessModal.vue';
	import cookies from 'js-cookie';
	export default {
		components: {
			promotionHome,
			orderSuccessModal,
		},
		props: {
			title: { type: String, default: '' },
			visible: { type: Boolean, default: false },
			price: { type: Number, default: 0 },
			code: { type: String, default: '' },
			showTime: { type: Boolean, default: false },
			step: { type: Number, default: 0 },
			onSubmit: { type: Function, default: null },
			text: {
				type: String,
				default: ``,
			},
		},
		data() {
			return {
				is_hidden_price: cookies.get('is_hidden_price'),
				touliuSelect: [],
				config_step: 100,
				isShow: false,
				tiered_total_amount: 0, //阶梯计价总金额
				isCheckTiered: false, //是否已进行阶梯计价检测
				tiered_detail: [],
				isFull: false, //是否全量计算 false为单个计算价格
				confirmLoading: false,
				compact: false,
				config_info: {},
				orderSuccessVisible: false,
				entity: {
					linkUrl: null,
					comment: null,
					orderNum: `${this.$lang.GetLangByKey('Amount')} 0${this.$lang.GetLangByKey('PriceUnit')}`,
					orderCount: null,
				},
				selectOptionTime: util.selectOptionTime(),
			};
		},
		mounted() {},
		methods: {
			onStep(value, type) {
				var config_step = this.config_step;
				console.log(this.entity.comment);
				let num = this.entity.comment % config_step;
				if (type.type == 'up') {
					this.entity.comment -= num;
				} else {
					if (this.entity.comment != 0) {
						this.entity.comment += config_step - (num === 0 ? config_step : num);
					}
				}
				console.log(`${value},${type}`);
			},
			blur() {},
			focus() {
				var urlList = [];
				this.entity.linkUrl?.split('\n').forEach((item) => {
					if (item) {
						urlList.push(item);
					}
				});
				var urlCount = urlList.length;
				console.log(urlCount + ',' + this.entity.orderCount + ',' + this.price);
				if (urlCount == 0 && !this.entity.orderCount) {
					return;
				}
				var amount = (
					(urlCount * this.entity.orderCount * this.price) /
					this.config_info.config_unit /
					1000
				).toFixed(2);
				this.entity.orderNum = `${this.$lang.GetLangByKey(
					'Amount'
				)} ${amount}${this.$lang.GetLangByKey('PriceUnit')}`;
				if (this.is_hidden_price == 1) {
					this.entity.orderNum = `${this.$lang.GetLangByKey('Amount')} **${this.$lang.GetLangByKey(
						'PriceUnit'
					)}`;
				}
			},
			confirmBtn() {
				alert(
					`linkUrl:${this.entity.linkUrl};comment:${this.entity.comment};orderNum:${this.entity.orderNum}`
				);
			},
			reset() {
				this.entity = {
					linkUrl: '',
					comment: null,
					orderNum: `${this.$lang.GetLangByKey('Amount')} 0${this.$lang.GetLangByKey('PriceUnit')}`,
					orderCount: null,
				};
			},
			//下单
			async order() {
				this.orderBtn();
			},
			async orderBtn() {
				console.log('窗口touliuBatchOrderModal 当前配置' + this.code);
				if (!this.entity.linkUrl) {
					this.$message.error('请输入TK账号，换行为一条数据');
					return;
				}
				if (this.entity.orderCount == null || this.entity.orderCount == 0) {
					this.$message.error('请选择投流数量');
					return;
				}
				let result = this.entity.orderCount % this.config_step;
				let err = `请输入${this.config_step}的倍数`;
				if (result != 0 || (this.entity.orderCount || 0) == 0) {
					this.$message.error(err);
					return;
				}
				var urlList = [];
				this.entity.linkUrl?.split('\n').forEach((item) => {
					if (item) {
						urlList.push(item);
					}
				});

				let param = {};
				let count = this.entity.orderCount;
				count = count * this.config_info.config_unit;

				if (!this.isFull) {
					count /= this.config_info.config_unit;
				}

				param.config_code = this.code;
				param.order_robot_count = count;
				param.order_links = urlList.join(',');
				console.log(param);

				this.onSubmit(param);
			},
		},

		setup() {},
		watch: {
			visible: {
				handler(a) {
					console.log('TransactionsModal窗口2当前配置' + a);
					this.isShow = a;
				},
			},
			isShow: {
				async handler(a) {
					this.$emit('changeVisible', a);
				},
			},
			code: {
				async handler(value) {
					if (value == 991001) {
						return;
					}
					console.log('TransactionsModal窗口当前配置' + value);
					if (value == 981006) {
						this.touliuSelect = [
							{ value: 10000, disc: '10000【投流粉丝】+100000【投流视频浏览量】' },
						];
					} else if (value == 981007) {
						this.touliuSelect = [{ value: 100000, disc: '100000【投流视频浏览量】' }];
					}
					var res = await orderApi.OrderInfo({ config_code: value });
					this.config_info = res.ret_obj;
					this.isFull =
						this.config_info.config_code == 1007 || this.config_info.config_code == 1003;
					this.config_step = res.ret_obj.config_step;
					console.log('加载数据..' + res);
				},
			},
		},
	};
</script>
<style lang="scss" scoped>
	.buttonGroup {
		padding-top: 25px;
		text-align: left;
	}

	.contentText {
		font-size: 12px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #0086f5;
		line-height: 18px;
		text-align: left;
		width: -webkit-fit-content;
		margin: 0px auto;
		width: 70%;
	}

	.contentWarp {
		:deep(.ant-input-number-handler) {
			border-left: none;
		}

		:deep(.ant-input-number-handler-up) {
			background-image: url(/src/assets/icon/icon-add.png);
			background-size: cover;
			background-color: white;
			width: 48%;
			height: 100% !important;
		}

		:deep(.ant-input-number-handler-down) {
			background-image: url(/src/assets/icon/icon-minus.png);
			background-size: cover;
			background-color: white;
			width: 48%;
			margin-left: 2%;
			height: 100% !important;
			border-top: none;
		}

		:deep(.ant-input-number-handler-wrap) {
			display: flex;
			position: absolute;
			right: -4.6rem;
			width: 4.4rem !important;
			height: 1.4rem;
			top: 0.2rem;
		}

		:deep(.anticon-up > svg) {
			display: none;
		}

		:deep(.anticon-down > svg) {
			display: none;
		}

		.TransactionsModal-wrap-tips {
			padding-left: 10%;
			padding-right: 10%;
		}

		.TransactionsModal-wrap-body {
			width: 85%;
			margin: 0px auto;

			.wrap-body-input {
				width: 100%;
				border-radius: 15px;
				text-align: left;
			}
		}

		::v-deep {
			.ant-modal-content {
				//   min-width: 449px;
				//   min-height: 597px;
				background: #e5f3ff;
				box-shadow: 4px 13px 20px 0px rgba(146, 146, 146, 0.49);
				border-radius: 12px;
			}

			.ant-modal-header {
				background: #e5f3ff;
				border-radius: 12px;
				text-align: center;
				border-bottom: 0px;
			}

			.ant-modal-title {
				font-size: 14px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: #0086f5;
				line-height: 20px;
			}

			.ant-input-group.ant-input-group-compact {
				.ant-select:last-child {
					.ant-select-selector {
						border-radius: 15px;
					}
				}
			}
		}
	}

	@media only screen and (max-width: 720px) {
		.contentWarp {
			.TransactionsModal-wrap-tips {
				padding-left: initial;
				padding-right: initial;
			}

			.TransactionsModal-wrap-body {
				width: 90%;
			}

			.contentText {
				width: 90%;
			}
		}
	}
</style>
